import React from 'react';

export default function Footer() {
	return <div className='footer fb ac jsa'>KhanaGhar react app @ 2023</div>;
}
